module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image16d.1ba90e20.webp";